/*=========================================================================================
  File Name: usersActions.js
  Description: Vuex Store - users actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    /**
     *
     * @param commit
     * @returns {Promise<unknown>}
     */
    getClientTypes({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/client-type', method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    storeClientType({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/client-type/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    updateClientType({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/client-type/update', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    deleteClientType({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/client-type/delete/' + id, method: 'DELETE'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    getClientTypeOptions({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/client-type/options', method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
};
